:host {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  gz-phasr-restricted-profiles-view {
    height: 100%;
  }
  .wrapper {
    width: 100%;
    height: 100%;
    padding-top: calc(var(--spacer) * 2);
    display: block;

    .content-wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      position: relative;

      gz-info-box {
        padding: calc(var(--spacer) * 1) 0 calc(var(--spacer) * 2) 0;
        span {
          font-weight: 500;
        }
      }
    }

    .loading-container {
      display: none;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;

      gz-progress-spinner {
        display: flex;
        justify-content: center;
      }
    }

    &.is-loading {
      .content-wrapper {
        display: none;
      }

      .loading-container {
        display: flex;
      }
    }
  }
}
